import "./App.css";
// import A11yCard from "../A11yCard";
import Highlights from "../Highlights";

function App() {
  return (
    <div className="app">
      <h1>A11y Story Cards</h1>
      <Highlights />
    </div>
  );
}

export default App;
